import { SectionTitle } from 'modules/marketplace-performance-page/components/section-title';

export const StatsLoading = () => {
  const LoadingList = () => (
    <div className="xxs:px-4 xxs:py-3 xxs:mb-2">
      <div className="flex justify-between">
        <div className="text-sm">
          <div className="h-1.5 w-16 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse xxs:mt-2" />
        </div>
        <div className="text-sm font-medium">
          <div className="h-1.5 w-16 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse xxs:mt-2" />
        </div>
      </div>
    </div>
  );

  const LoadingContent = () => (
    <div className=" xxs:p-4 xxs:py-6 space-y-20">
      <SectionTitle>
        <div className="h-2 w-16 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse" />
      </SectionTitle>
      <div className="space-y-6">
        <div className="h-3 w-16 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse" />
        <div className="h-3 w-20 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse" />
        <div className="h-3 w-16 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse" />
      </div>
    </div>
  );

  const LoadingMainPerformance = () => (
    <>
      <div className="flex justify-center xxs:mb-2 items-center border-bottom-new border-b-1 xxs:border-b-1 xxs:border-black-50 dark:border-black-400 xxs:py-4">
        <div className="text-center xxs:py-6">
          <div className="h-3 w-16 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse" />
          <div className="h-1.5 w-16 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse xxs:mt-2" />
        </div>
      </div>

      {Array.from(Array(9).keys()).map((id) => {
        return <LoadingList key={id} />;
      })}

      <div className="xxs:py-6 xxs:px-4 border-bottom-new border-b-1 xxs:border-b-1 xxs:border-black-50 dark:border-black-400">
        <div className="flex justify-between">
          <div className="text-sm">
            <div className="h-1.5 w-16 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse xxs:mt-2" />
          </div>
          <div className="text-sm font-medium">
            <div className="h-1.5 w-16 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse xxs:mt-2" />
          </div>
        </div>
      </div>

      {Array.from(Array(4).keys()).map((id) => {
        return <LoadingList key={id} />;
      })}
    </>
  );

  return (
    <>
      <div className="lg:w-2/5 xl:w-1/4 hidden lg:block">
        <div className="bg-white-100 dark:bg-black-800 rounded-md shadow-md h-full ">
          <div className="xxs:py-6 lg:px-4 bg-white-300 dark:bg-black-700 xxs:rounded-t-md font-normal text-lg border-bottom-new xxs:border-b-1 xxs:border-black-50 dark:border-black-400">
            <div className="h-2 w-16 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse" />
          </div>
          <LoadingMainPerformance />
        </div>
      </div>
      <div className="w-full lg:w-3/5 xl:w-3/4 ">
        <div className="bg-white-100 dark:bg-black-800 rounded-md shadow-md h-full ">
          <ul className="xxs:py-6 xxs:px-4 list-none flex flex-wrap bg-white-300 dark:bg-black-700 xxs:rounded-t-md xxs:p-1 mb-0 text-lg border-bottom-new xxs:border-b-1 xxs:border-black-50 dark:border-black-400 space-x-4">
            <div className="h-2 w-16 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse" />
            <div className="h-2 w-16 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse lg:hidden" />
            <div className="h-2 w-16 rounded-xl bg-white-600 dark:bg-white-900 animate-pulse" />
          </ul>
          <div className="lg:hidden">
            <LoadingMainPerformance />
          </div>
          <div className="lg:block hidden">
            <LoadingContent />
            <div className="xxs:py-16">
              <LoadingContent />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
